import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'companies';
export const companiesActions = makeActions(MODEL_NAME);

export const getAllCompanies = companiesActions.getAll;
export const editCompanies = companiesActions.edit;
export const createCompanies = companiesActions.create;
export const getByIdCompanies = companiesActions.getDataById;
